class InteractiveProductSpotlight extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.cacheElements();
    this.bindEvents();

    this.initialized = true;
  }

  disconnectedCallback() {
    if (!this.initialized) return;

    this.buttons.forEach((button) => button.removeEventListener('click', this.handleButtonClick));
    this.swatchButtons.forEach((button) => button.removeEventListener('click', this.handleSwatchClick));
    if (this.overlay) this.overlay.removeEventListener('click', this.handleOverlayClick);
    document.removeEventListener('keydown', this.handleKeydown);
  }

  cacheElements() {
    this.buttons = Array.from(this.querySelectorAll('[data-hotspot-trigger]'));
    this.overlay = this.querySelector('[data-hotspot-overlay]');
    this.closeButton = this.querySelector('[data-hotspot-close]');
    this.modalImage = this.querySelector('[data-modal-image]');
    this.modalTitle = this.querySelector('[data-modal-title]');
    this.modalText = this.querySelector('[data-modal-text]');
    this.swatchButtons = Array.from(this.querySelectorAll('[data-swatch-trigger]'));
    this.mediaItems = Array.from(this.querySelectorAll('[data-media-item]'));
  }

  bindEvents() {
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleSwatchClick = this.handleSwatchClick.bind(this);
    this.handleOverlayClick = this.handleOverlayClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);

    this.buttons.forEach((button) => button.addEventListener('click', this.handleButtonClick));
    this.swatchButtons.forEach((button) => button.addEventListener('click', this.handleSwatchClick));
    if (this.overlay) this.overlay.addEventListener('click', this.handleOverlayClick);
    document.addEventListener('keydown', this.handleKeydown);

    if (this.swatchButtons.length && this.mediaItems.length) {
      const activeButton = this.swatchButtons.find((button) => button.classList.contains('is-active')) || this.swatchButtons[0];

      if (activeButton) {
        this.setActiveSwatch(activeButton.dataset.swatchTrigger);
      }
    }
  }

  handleButtonClick(event) {
    const button = event.currentTarget;
    this.openModal(button.dataset.hotspotId);
  }

  handleSwatchClick(event) {
    const button = event.currentTarget;
    this.setActiveSwatch(button.dataset.swatchTrigger);
  }

  handleOverlayClick(event) {
    if (event.target === this.overlay || event.target === this.closeButton) {
      this.closeModal();
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape') this.closeModal();
  }

  openModal(hotspotId) {
    const source = this.querySelector(`[data-hotspot-content="${hotspotId}"]`);
    if (!source) return;

    this.setModalPart(this.modalImage, source.querySelector('[data-source-image]'));
    this.setModalPart(this.modalTitle, source.querySelector('[data-source-title]'));
    this.setModalPart(this.modalText, source.querySelector('[data-source-text]'));
    this.classList.add('is-modal-open');
  }

  closeModal() {
    this.classList.remove('is-modal-open');
  }

  setModalPart(target, source) {
    if (!target) return;
    target.innerHTML = source ? source.innerHTML : '';
  }

  setActiveSwatch(targetId) {
    if (!targetId) return;

    this.swatchButtons.forEach((button) => {
      const isActive = button.dataset.swatchTrigger === targetId;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    this.mediaItems.forEach((item) => {
      const isActive = item.dataset.mediaItem === targetId;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  }
}

if (!customElements.get('interactive-product-spotlight')) {
  customElements.define('interactive-product-spotlight', InteractiveProductSpotlight);
}
